import { graphql, useStaticQuery } from "gatsby";

export const useNewsLinks = () => {
    const { links } = useStaticQuery(graphql`
        query InTheNewsQuery {
            links: allContentfulInTheNewsLink(sort: { date: DESC }) {
                edges {
                    node {
                        title
                        publisher
                        date(formatString: "MMMM D, YYYY")
                        url
                    }
                }
            }
        }
    `);

    return links.edges;
};
